import React from 'react';
import { FormattedMessage } from 'react-intl';
import fieldKeys from './fieldKeys';

export default {
    [fieldKeys.CHECKOUT_COMPLETE]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.transferOffer.checkout_complete"
            defaultMessage="Because you have already gone through checkout for this item, we are unable to complete a transfer at this time."
        />
    ),
    [fieldKeys.ITEM_NOT_AVAILABLE]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.transferOffer.unavailable"
            defaultMessage="Because this item is not currently available for purchase, we are unable to complete a transfer at this time."
        />
    ),
    [fieldKeys.ITEM_ON_HOLD]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.transferOffer.onhold"
            defaultMessage="Because this item is on hold for another buyer, we are unable to complete a transfer at this time."
        />
    ),
    [fieldKeys.SYSTEM_ERROR]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.transferOffer.system_error"
            defaultMessage="We are unable to complete a transfer at this time. Please try again later."
        />
    ),
    [fieldKeys.GENERAL_INQUIRY]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.transferOffer.general_inquiry"
            defaultMessage="General inquiries to sellers cannot be transferred."
        />
    ),
};
